<template>
  <div class="m-collapse" :class="{ 'is-open': isOpen }" ref="collapse">
    <button
      type="button"
      class="m-collapse__title"
      :aria-expanded="isOpen ? 'true' : 'false'"
      :aria-controls="id"
      @click="toggle"
    >
      <svg class="m-collapse__icon" aria-hidden="true">
        <use v-if="!isOpen" :xlink:href="$root.spritePath + '#plus'"/>
        <use v-if="isOpen" :xlink:href="$root.spritePath + '#minus'"/>
      </svg>
      <span><slot name="title"></slot></span>
    </button>

    <transition
      @before-enter="beforeEnter"
      @enter="enter"
      @after-enter="afterEnter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <div
        class="m-collapse__content"
        v-show="isOpen"
        :aria-expanded="isOpen ? 'true' : 'false'"
        :aria-hidden="!isOpen ? 'true' : 'false'"
        :id="id"
      >
        <div class="m-collapse__inner" ref="collapseInner">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      id: "collapse_" + uuidv4(),
    }
  },
  inject: ["register", "unregister", 'collapseChange'],
  created() {
    if (this.register) {
      this.register(this)
    }
  },
  mounted() {
    this.isOpen = this.opened
  },
  unmounted() {
    if (this.unregister) {
      this.unregister(this)
    }
  },
  methods: {
    close() {
      this.isOpen = false
    },
    toggle() {
      this.isOpen = !this.isOpen

      if (this.collapseChange) {
        this.collapseChange(this, this.isOpen)
      }
    },
    beforeEnter(element) {
      requestAnimationFrame(() => {
        if (!element.style.height) {
          element.style.height = '0px';
        }

        element.style.display = null;
      });

    },
    enter(element) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          element.style.height = `${element.scrollHeight}px`;
        });
      });
    },
    afterEnter(element) {
      element.style.height = null;
    },
    beforeLeave(element) {
      requestAnimationFrame(() => {
        if (!element.style.height) {
          element.style.height = `${element.offsetHeight}px`;
        }
      });
    },
    leave(element) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          element.style.height = '0px';
        });
      });
    },
  },
}
</script>
